<template>
    <v-layout row justify-center>
        <v-dialog
        :value="budgetPlannerDialog"
        @input="reset()"
        persistent
        scrollable
        max-width="50vw">
        <v-card>
            <v-card-title class="pa-4">
                <div>
                <div class="title">{{$t('screener.budget_planner.title')}}</div>
                <div class="subheading pt-1 greyDarken2--text">{{$t('screener.budget_planner.subtitle')}}</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                    class="mx-0 px-0"
                    small
                    dark
                    icon
                    color="grey"
                    @click="reset()"
                >
                    <v-icon small>$vuetify.icons.rms_close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="max-height: 80vh" class="px-4">
                <ScreenerSeatsPlanner
                :slots.sync="slots"
                :total_participants.sync="total_participants"
                @onCancel="reset"
                ref="screenerSeatsPlanner"
                ></ScreenerSeatsPlanner>
                <Faqs
                class="mt-3"
                :faqs="DEFINES.PREMIUM_SCREENING_FAQS"
                ></Faqs>
            </v-card-text>
        </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import ScreenerSeatsPlanner from "@/components/screener/SeatsPlanner";
import Faqs from "@/components/FAQs";

export default {
    name:"EventBudgetPlanner",
    props: {
        budgetPlannerDialog: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            slots: [],
            total_participants:0
        }
    },
    components:{
        ScreenerSeatsPlanner,
        Faqs
    },
    methods:{
        reset() {
            // Reset everything
            this.$emit("update:budgetPlannerDialog", false);
        },
    }
}
</script>

<style>

</style>
